import { Descriptions, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { CallContent as CallContentType } from '../../../../model/types';
import { getCurrentUserRole, isAdmin } from '../../../../utils/accountHelper';
import { getFormattedDateWithHourWithDayjs } from '../../../../utils/helpers';
import { ConversationProps } from '../Conversation';

type CallContentProps = Pick<ConversationProps, 'conversation'>;

const styles = {
    content: { fontSize: 11 },
    label: {
        fontWeight: 'bold',
        fontSize: 11
    },
    root: { marginTop: '1rem' },
    title: {
        fontSize: 12
    },
    downloadText: { marginLeft: '1rem' }
};

function CallDetail({ call }: { call: CallContentType }) {
    return (
        <Descriptions
            className="call-detail"
            column={1}
            contentStyle={styles.content}
            labelStyle={styles.label}
            size="small"
            title={
                <Typography.Text style={styles.title} underline>
                    Call Detail
                </Typography.Text>
            }
        >
            <Descriptions.Item label="Call from">{call.comment.creator.phone}</Descriptions.Item>
            <Descriptions.Item label="Call to">{call.destination}</Descriptions.Item>
            <Descriptions.Item label="Time of call">
                {getFormattedDateWithHourWithDayjs(call.createdAt)}
            </Descriptions.Item>
            <Descriptions.Item label="Location">{null}</Descriptions.Item>
            <Descriptions.Item label="Answered by">{call.comment.creator.fullName}</Descriptions.Item>
            <Descriptions.Item label="Length of phone call">{`${call.callDuration ?? 0} seconds`}</Descriptions.Item>
        </Descriptions>
    );
}
export default function CallContent({ conversation }: CallContentProps) {
    const currentUserRole = getCurrentUserRole();
    const isCurrentUserAdmin = isAdmin(currentUserRole);
    const { t } = useTranslation('tickets');
    return (
        <div style={styles.root}>
            {conversation.call?.recording?.objectUrl && (
                <>
                    {isCurrentUserAdmin && ( //Only admins can see call records
                        <Row align="middle">
                            <audio controls src={conversation.call.recording.objectUrl} preload="metadata" />

                            <Typography.Link
                                style={styles.downloadText}
                                href={conversation.call?.recording?.objectUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t('downloadCallRecord')}
                            </Typography.Link>
                        </Row>
                    )}
                </>
            )}
            <CallDetail call={conversation.call} />
        </div>
    );
}
